/**
 * The slot registrations of `web/foundry` (CS r6c deliverable 204, taken over by 2.I-2): the
 * sidebar's "Import from Foundry" (`shell.workspace.foundry`) and the Settings section
 * (`settings.sections.foundry`), both at order 30 (DECISIONS 778: the bootstrap wizard holds 20),
 * and `FoundryDocTools` in the header's pills (`header.pills.refresh`, order 76): the biography
 * runner (stage s1) and the refresh pill (stage s2). Each draws nothing with `flag:sheets` off.
 * `apps/web/src/editor-services/slots.ts` collects them as `SLOT_MODULES['web/foundry']`.
 */
import type { SlotRegistration, WorkPackageId } from '@codex/contracts';
import { FoundryDocTools } from './biography/doc-tools.js';
import { SettingsFoundrySection, SidebarFoundryEntry } from './entry.js';

export const owner: WorkPackageId = '2.I-2';

export const slotRegistrations: readonly SlotRegistration[] = [
  { slot: 'shell.workspace', order: 30, owner: '2.I-2', component: SidebarFoundryEntry },
  { slot: 'settings.sections', order: 30, owner: '2.I-2', component: SettingsFoundrySection },
  { slot: 'header.pills', order: 76, owner: '2.I-2', component: FoundryDocTools },
];
